import { styled } from "@mui/material/styles";
import { green } from "designSystem/styles/color";
import { FlexRowCenter, OverflowText } from "designSystem/index";
import React, { FunctionComponent } from "react";

const PREFIX = "SuggestedChip";

const classes = {
	root: `${PREFIX}root`,
	slimRoot: `${PREFIX}slimRoot`,
};

const StyledFlexRowCenter = styled(FlexRowCenter)(({
	theme,
}) => ({
	[`&.${classes.root}`]: {
		backgroundColor: green[100],
		borderRadius: 3,
		color: green[700],
		height: 17,
		marginLeft: 8,
		overflow: "hidden",
		padding: 4,
	},

	[`&.${classes.slimRoot}`]: {
		backgroundColor: green[100],
		borderRadius: 3,
		color: green[700],
		height: 17,
		marginLeft: 4,
		overflow: "hidden",
		padding: "0 4px",
	},
}));

interface SuggestedChipProps {

	/** whether we should render the slim version of the component or not (less padding/margins; inlined) */
	slim?: boolean;

}

const SuggestedChip: FunctionComponent<SuggestedChipProps> = ({ slim = false }) => {
	return (
		<StyledFlexRowCenter className={slim ? classes.root : classes.slimRoot} inline={slim}>
			<OverflowText
				bold
				lineHeight={12}
				res="Suggested"
				uppercase
			/>
		</StyledFlexRowCenter>
	);
};

export default SuggestedChip;